import { Component, OnInit, Input, OnDestroy, ViewChild, OnChanges } from '@angular/core';
import { NavbarService } from './../../navbar/navbar.service';
import { BaseService } from '../../../shared-service/base.service';
import { EsignComponent } from '../../../shared-components/e-sign/esign.component';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { WindowRef } from '../../../shared-service/windowRef.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'announcement-detail',
  templateUrl: './announcement-detail.component.html',
  styleUrls: ['./announcement-detail.component.css']
})
export class AnnouncementDetailComponent implements OnInit, OnDestroy, OnChanges {


  @Input() AnnouncementSummary: Object|any = {};

  private IsAccepted: boolean = false;

  constructor(private navbarService: NavbarService, public bs: BaseService, private router: Router ,private winRef: WindowRef) {
    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((e: NavigationEnd|any) => {
      if (this.esign.IsEsignPopupOpen()) {
        this.esign.closePanel();
      }
    });
  }

  private storageAnnouncementDetailsKey: PropertyKey = 'AnnouncementDetailsKey';
  public ClassName: string="";
  public BookClassName: string="";

  public EnableESign: boolean = false;

  @ViewChild(EsignComponent) esign!: EsignComponent;

  ngOnInit() {
    this.resetPane();
  }

  resetPane() {
    this.IsAccepted = this.AnnouncementSummary['IsRead'];
    this.EnableESign = this.bs.getUserAttr("EnableESign");
    if (this.AnnouncementSummary['IsRead']) {
      this.ClassName = "announcement-tab-list-box active";
      this.BookClassName = "book-icon book-icon-opacity";
    }
    else {
      this.ClassName = "announcement-tab-list-box";
      this.BookClassName = "book-icon";
    }    
  }

  ngOnChanges() {
    this.resetPane();
  }

  ngOnDestroy() {
    this.esign.closePanel();
  }

  closeAnnouncementDetail() {
    let bodyTag:any = this.winRef.nativeWindow.document.getElementById("announcementDetail");
    bodyTag.className = bodyTag.className.replace("show", " ");
    this.esign.closePanel();
  }

  readAnnouncement(AnnoncementId: any, IsRead: boolean, IsAcknowledgementRequired: boolean) {

    if (!IsRead && !this.IsAccepted) {
      if (!this.EnableESign)
        this.SetAnnouncementRead(AnnoncementId);
      else if (IsAcknowledgementRequired)
        this.esign.openModelPopup(AnnoncementId,true);
      else
        this.SetAnnouncementRead(AnnoncementId);
    }
  }


  SetAnnouncementRead(AnnoncementId: any) {
    let params = {
      'AnnoncementId': AnnoncementId,
    };
    this.navbarService.setPublicAnnouncementReadFromServer(params, this.storageAnnouncementDetailsKey).then((data) => {
      if (data == "T") {
        this.bs.announcementCount = this.bs.announcementCount - 1;
        this.ClassName = "announcement-tab-list-box active";
        this.BookClassName = "book-icon book-icon-opacity";
        let unreadCount = parseInt($("#unreadCount").html()) - 1;
        $("#unreadCount").html(unreadCount);
        $("#announcementDiv" + AnnoncementId).addClass("active");
        this.IsAccepted = true;
      }
    },
      (data) => {
        this.bs.log('error', 'Error in getting list');
      });
  }

  AcknowledgeEsign(eventObj:any) {
    let announcementId: any = eventObj;
    this.SetAnnouncementRead(announcementId);
    this.esign.closePanel();
  }
}


